/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { YoutubeVideoConfigInfoRespVo } from './YoutubeVideoConfigInfoRespVo';
import {
    YoutubeVideoConfigInfoRespVoFromJSON,
    YoutubeVideoConfigInfoRespVoFromJSONTyped,
    YoutubeVideoConfigInfoRespVoToJSON,
    YoutubeVideoConfigInfoRespVoToJSONTyped,
} from './YoutubeVideoConfigInfoRespVo';

/**
 * 
 * @export
 * @interface PageDataYoutubeVideoConfigInfoRespVo
 */
export interface PageDataYoutubeVideoConfigInfoRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataYoutubeVideoConfigInfoRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataYoutubeVideoConfigInfoRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataYoutubeVideoConfigInfoRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<YoutubeVideoConfigInfoRespVo>}
     * @memberof PageDataYoutubeVideoConfigInfoRespVo
     */
    records?: Array<YoutubeVideoConfigInfoRespVo>;
}

/**
 * Check if a given object implements the PageDataYoutubeVideoConfigInfoRespVo interface.
 */
export function instanceOfPageDataYoutubeVideoConfigInfoRespVo(value: object): value is PageDataYoutubeVideoConfigInfoRespVo {
    return true;
}

export function PageDataYoutubeVideoConfigInfoRespVoFromJSON(json: any): PageDataYoutubeVideoConfigInfoRespVo {
    return PageDataYoutubeVideoConfigInfoRespVoFromJSONTyped(json, false);
}

export function PageDataYoutubeVideoConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataYoutubeVideoConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(YoutubeVideoConfigInfoRespVoFromJSON)),
    };
}

export function PageDataYoutubeVideoConfigInfoRespVoToJSON(json: any): PageDataYoutubeVideoConfigInfoRespVo {
    return PageDataYoutubeVideoConfigInfoRespVoToJSONTyped(json, false);
}

export function PageDataYoutubeVideoConfigInfoRespVoToJSONTyped(value?: PageDataYoutubeVideoConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(YoutubeVideoConfigInfoRespVoToJSON)),
    };
}

